<template>
  <v-row no-gutters :justify="justify" :align="align">
    <slot />
  </v-row>
</template>

<script>
export default {
  name: 'AppRow',

  props: {
    justify: {
      type: String,
      required: false,
    },
    align: {
      type: String,
      required: false,
    },
    containsInputFields: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style>
</style>